import { FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox, ListItemText, SelectChangeEvent, CircularProgress, InputAdornment } from "@mui/material";
import { useEffect, useState } from "react";
import { CardSwapStatusDto } from "./dtos/CardSwapStatusDto";
import { useCardSwapHttp } from "./hooks/useCardSwapHttp";
import { useCookies } from "react-cookie";


type CardSwapStatusesSelectProps = { 

    defaultCardSwapStatuses : string[ ],
    selectCardSwapStatuses:( cardSwapStatuses: string[] ) => void

};


export const CardSwapStatusesSelect : React.FC< CardSwapStatusesSelectProps > = ( props : CardSwapStatusesSelectProps) => {

    const { defaultCardSwapStatuses, selectCardSwapStatuses } = props;

    const [ cardSwapStatuses,  setCardSwapStatuses ] = useState< CardSwapStatusDto[] >( [ ] );
    const [ isLoading, setIsLoading ] = useState< boolean >( true );
    const [ selectedCardSwapStatuses, setSelectedCardSwapStatuses ] = useState< string[] >( [] );


    const { getCardSwapStatuses } = useCardSwapHttp( );

    const [ cookies, setCookie, removeCookie ] = useCookies( );


    useEffect( ( ) => {
        
        const fetchData = async ( ) => {

            const cardSwapStatuses = await getCardSwapStatuses( );
            setIsLoading( false );

            if( cardSwapStatuses ) {
                
                setCardSwapStatuses( cardSwapStatuses );

            }

        }; 

        fetchData( );

    }, [ ]);


    useEffect( ( ) => {

        if( defaultCardSwapStatuses.length === 0 || selectedCardSwapStatuses.length > 0 || cardSwapStatuses.length === 0 ){
            
            return;

        }

        const validatedCardSwapStatuses = defaultCardSwapStatuses.filter( m => cardSwapStatuses.map( c => c.code ).includes( m ) ); // check if the status actually exists
        
        setSelectedCardSwapStatuses( validatedCardSwapStatuses ); 
        setCookie( 'card-swap-statuses', JSON.stringify( validatedCardSwapStatuses ) );

        
    }, [ cardSwapStatuses, defaultCardSwapStatuses ]);


    const handleCardSwapStatusesChange = ( event: SelectChangeEvent<typeof selectedCardSwapStatuses> ) => {

        const value = event.target.value;

        const newSelectedCardSwapStatuses = typeof value === 'string' ? value.split( ',' ) : value; // On autofill we get a stringified value

        setSelectedCardSwapStatuses( newSelectedCardSwapStatuses );

        selectCardSwapStatuses( newSelectedCardSwapStatuses ); 

    };


    return(

        <FormControl sx={{ width: '429px' }}>
            <InputLabel>Card Swap Status</InputLabel>
            <Select
                multiple
                value={ selectedCardSwapStatuses }
                onChange={ handleCardSwapStatusesChange }
                input={ <OutlinedInput label="Card Swap Status" /> }
                renderValue={ selected => cardSwapStatuses.filter( cardSwapStatus => selected.includes( cardSwapStatus.code ) ).map( x => x.description ).join( ', ' ) }
                endAdornment={
                    isLoading
                        &&
                    <InputAdornment position="end">
                      <CircularProgress size={ 30 } sx={{ backgroundColor : 'white' }} />
                    </InputAdornment>
                }
             >
                { cardSwapStatuses.map( cardSwapStatus => (
                    <MenuItem key={cardSwapStatus.code} value={cardSwapStatus.code}>
                        <Checkbox checked={ selectedCardSwapStatuses.indexOf( cardSwapStatus.code ) > -1 } />
                        <ListItemText primary={ cardSwapStatus.description } />
                    </MenuItem>
                ))}
             </Select>
         </FormControl>

    );

};